import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { detectLanguage } from '@/services/geoService';

// Import translation files
import enCommon from './locales/en/common.json';
import enAuth from './locales/en/auth.json';
import enDashboard from './locales/en/dashboard.json';
import enSim from './locales/en/sim.json';
import enModem from './locales/en/modem.json';
import enPsi from './locales/en/psi.json';
import enBom from './locales/en/bom.json';
import enWork from './locales/en/work.json';
import enKanban from './locales/en/kanban.json';
import enLanding from './locales/en/landing.json';
import enProject from './locales/en/project.json';
import enBlog from './locales/en/blog.json';
import enTtqs from './locales/en/ttqs.json';
import enMes from './locales/en/mes.json';
import enWebflash from './locales/en/webflash.json';
import enDocflow from './locales/en/docflow.json';
import enPomodoro from './locales/en/pomodoro.json';
import enPurchaseflow from './locales/en/purchaseflow.json';
import enMistakeNotebook from './locales/en/mistakeNotebook.json';

import zhTWCommon from './locales/zh-TW/common.json';
import zhTWAuth from './locales/zh-TW/auth.json';
import zhTWDashboard from './locales/zh-TW/dashboard.json';
import zhTWSim from './locales/zh-TW/sim.json';
import zhTWModem from './locales/zh-TW/modem.json';
import zhTWPsi from './locales/zh-TW/psi.json';
import zhTWBom from './locales/zh-TW/bom.json';
import zhTWWork from './locales/zh-TW/work.json';
import zhTWKanban from './locales/zh-TW/kanban.json';
import zhTWLanding from './locales/zh-TW/landing.json';
import zhTWProject from './locales/zh-TW/project.json';
import zhTWBlog from './locales/zh-TW/blog.json';
import zhTWTtqs from './locales/zh-TW/ttqs.json';
import zhTWMes from './locales/zh-TW/mes.json';
import zhTWWebflash from './locales/zh-TW/webflash.json';
import zhTWDocflow from './locales/zh-TW/docflow.json';
import zhTWPomodoro from './locales/zh-TW/pomodoro.json';
import zhTWPurchaseflow from './locales/zh-TW/purchaseflow.json';
import zhTWMistakeNotebook from './locales/zh-TW/mistakeNotebook.json';

import viCommon from './locales/vi/common.json';
import viAuth from './locales/vi/auth.json';
import viLanding from './locales/vi/landing.json';

import filCommon from './locales/fil/common.json';
import filAuth from './locales/fil/auth.json';
import filLanding from './locales/fil/landing.json';

import idCommon from './locales/id/common.json';
import idAuth from './locales/id/auth.json';
import idLanding from './locales/id/landing.json';

import msCommon from './locales/ms/common.json';
import msAuth from './locales/ms/auth.json';
import msLanding from './locales/ms/landing.json';

const resources = {
  en: {
    common: enCommon,
    auth: enAuth,
    dashboard: enDashboard,
    sim: enSim,
    modem: enModem,
    psi: enPsi,
    bom: enBom,
    work: enWork,
    kanban: enKanban,
    landing: enLanding,
    project: enProject,
    blog: enBlog,
    ttqs: enTtqs,
    mes: enMes,
    webflash: enWebflash,
    docflow: enDocflow,
    pomodoro: enPomodoro,
    purchaseflow: enPurchaseflow,
    mistakeNotebook: enMistakeNotebook,
  },
  'zh-TW': {
    common: zhTWCommon,
    auth: zhTWAuth,
    dashboard: zhTWDashboard,
    sim: zhTWSim,
    modem: zhTWModem,
    psi: zhTWPsi,
    bom: zhTWBom,
    work: zhTWWork,
    kanban: zhTWKanban,
    landing: zhTWLanding,
    project: zhTWProject,
    blog: zhTWBlog,
    ttqs: zhTWTtqs,
    mes: zhTWMes,
    webflash: zhTWWebflash,
    docflow: zhTWDocflow,
    pomodoro: zhTWPomodoro,
    purchaseflow: zhTWPurchaseflow,
    mistakeNotebook: zhTWMistakeNotebook,
  },
  vi: {
    common: viCommon,
    auth: viAuth,
    landing: viLanding,
  },
  fil: {
    common: filCommon,
    auth: filAuth,
    landing: filLanding,
  },
  id: {
    common: idCommon,
    auth: idAuth,
    landing: idLanding,
  },
  ms: {
    common: msCommon,
    auth: msAuth,
    landing: msLanding,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    supportedLngs: ['en', 'zh-TW', 'vi', 'fil', 'id', 'ms'],
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'i18n_language',
      caches: ['localStorage'],
    },
    interpolation: {
      escapeValue: false,
    },
    ns: ['common', 'auth', 'dashboard', 'sim', 'modem', 'psi', 'bom', 'work', 'kanban', 'landing', 'project', 'blog', 'ttqs', 'mes', 'webflash', 'docflow', 'pomodoro', 'purchaseflow', 'mistakeNotebook'],
    defaultNS: 'common',
  })
  .then(() => {
    // On first visit (no saved language), detect country via GCP LB geo header
    if (!localStorage.getItem('i18n_language')) {
      detectLanguage()
        .then((geo) => {
          if (geo.language && geo.language !== i18n.language) {
            i18n.changeLanguage(geo.language);
          }
        })
        .catch(() => {
          // Silently fall back to existing navigator/default detection
        });
    }
  });

export default i18n;
